import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { unwrapConnection } from 'src/app/shared/rxjs.pipes';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ExpenseItemService, ExpenseCategoryService, ExpenseApplicationService, ExpenseTypeService, TimeEntryTypeService } from 'src/app/shared/services';
import { IApiAddExpenseItemInput, IApiExpenseApplication, IApiExpenseCategory, IApiExpenseItem, IApiExpenseType, IApiSageItemResponse, IApiUpdateExpenseItemInput } from "src/app/shared/modules/graphql/types/types";
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { forkJoin } from 'rxjs';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { NgForm } from '@angular/forms';

@Component({
  templateUrl: './expense-item-modal.component.html',
  styleUrls: ['./expense-item-modal.component.scss']
})
export class ExpenseItemModalComponent extends DialogContentBase implements OnInit {
  @ViewChild('form', { static: false }) form: NgForm;
  @Input() data: IApiExpenseItem;

  public expenseCategories: IApiExpenseCategory[];
  public expenseApplications: IApiExpenseApplication[];
  public expenseTypes: IApiExpenseType[];
  public sageList: IApiSageItemResponse[] = [];

  public model: IApiUpdateExpenseItemInput = {
    id: "",
    name: "",
    ExpenseCategoryId: "",
    ExpenseTypeId: "",
    ExpenseApplicationId: "",
    description: '',
    active: false,
    sageId: null,
    value: 0,
  };

  constructor(
    private expenseItemService: ExpenseItemService,
    private expenseApplicationService: ExpenseApplicationService,
    private expenseCategoryService: ExpenseCategoryService,
    private expenseTypeService: ExpenseTypeService,
    private notifications: NotificationsService,
    private loaderService: LoaderService,
    public dialog: DialogRef,
    private timeEntryTypeService: TimeEntryTypeService,
  ) {
    super(dialog);
  }

  private save() {
    this.loaderService.show$(this.expenseItemService.update({
      ...this.model,
      id: this.data.id,
      value: this.model.value || 0,
      name: this.model.name?.trim(),
      description: this.model.description?.trim(),
      sageId: this.model.sageId || null,
      qbAccount: this.sageList?.find(sage => sage.id === this.model.sageId)?.name || ''
    })).pipe(
      this.notifications.snackbarErrorPipe("Error updating expense item."),
      this.notifications.snackbarPipe("Expense item updated.")
    ).subscribe((res) => this.dialog.close(res));
  }

  private add() {
    const createData = {
      ...this.model, value: this.model.value || 0,
      qbAccount: this.sageList?.find(sage => sage.id === this.model.sageId)?.name || ''
    };
    delete createData.id;
    this.loaderService.show$(this.expenseItemService.add(createData as IApiAddExpenseItemInput)).pipe(
      this.notifications.snackbarErrorPipe("Error adding expense item."),
      this.notifications.snackbarPipe("Expense item created.")
    ).subscribe((res) => this.dialog.close(res));
  }

  onSubmit() {
    if (this.form?.invalid) {
      this.form.form.markAllAsTouched();
      return;
    };
    const { id = null } = this.data || {};
    if (id) this.save();
    else this.add();
  }

  close() {
    this.dialog.close();
  }

  ngOnInit() {
    const {
      id = "",
      name = "",
      ExpenseCategory: { id: ExpenseCategoryId = "" } = {},
      ExpenseType: { id: ExpenseTypeId = "" } = {},
      AppliesTo: { id: ExpenseApplicationId = "" } = {},
      description = '',
      value = 0,
      sageId = null
    } = this.data || {};
    this.loaderService.show$(forkJoin([
      this.expenseCategoryService.get().pipe(unwrapConnection()),
      this.expenseApplicationService.get().pipe(unwrapConnection()),
      this.expenseTypeService.get().pipe(unwrapConnection()),
      this.timeEntryTypeService.getSageItemList()
    ])).subscribe(([expenseCategories, expenseApplications, expenseTypes, sageLists]) => {
      this.expenseCategories = expenseCategories;
      this.expenseApplications = expenseApplications;
      this.expenseTypes = expenseTypes;
      this.sageList = sageLists;
      this.model = {
        id,
        name,
        ExpenseCategoryId,
        ExpenseTypeId,
        ExpenseApplicationId,
        description,
        active: !id,
        value,
        sageId,
      };
      if (this.data.id) {
        const sageItem = this.sageList?.find(item => item.id === this.model.sageId);
        if (!sageItem?.id) {
          this.model.sageId = null
        }
      }
    });

  }
}
